import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NotAuthorizedInterceptor } from "./auth.interceptor";

@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: NotAuthorizedInterceptor, multi: true }
  ]
})
export class AuthInterceptorModule {}